import { ConnectedPosition } from '@angular/cdk/overlay';

export const RIGHT_POSITION: ConnectedPosition[] = [
    {originX: 'end', originY: 'center', overlayX: 'start', overlayY: 'center', offsetX: 5},
    {originX: 'start', originY: 'center', overlayX: 'end', overlayY: 'center', offsetX: 5},
];
